module.exports = __webpack_public_path__ + "officialStatic/img/contact-bg.b89d98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/contact-bg.png
// module id = MZlw
// module chunks = 0